import { Component, ComponentRef, EventEmitter, Input, Output, signal, ViewChild } from '@angular/core';
import { WindowComponent } from 'movisat-common-gui';
import { AppComponent } from 'src/app/app.component';
import { CerraduraModel } from 'src/app/services/cerraduras/models/cerradura.model';
import { environment } from 'src/environments/environment';
import { JqxSubTabsComponent } from '../jqx-sub-tabs/jqx-sub-tabs.component';
import { MenuComponent } from 'src/app/components/main/menu/menu.component';

@Component({
  selector: 'app-detalle-cerradura',
  standalone: false,
  templateUrl: './detalle-cerradura.component.html',
  styleUrl: './detalle-cerradura.component.css'
})
export class DetalleCerraduraComponent {
  @ViewChild('detalleCerradura') public detalleCerradura: WindowComponent;

  @Input() protected cerradura: CerraduraModel = new CerraduraModel();
  @Output() protected closeForm = new EventEmitter();

  public theme = environment.tema;
  private componentRef = null;

  protected loading = signal(false);
  protected actions = [
    {type: "button", action:"exit", value: "", label: this.translate('Salir')}
  ];

  public actionButtonClicked(event: {action: string}): void {
    if(event.action === 'exit') {
      this.detalleCerradura.closeWindow()
      return;
    }
  }

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public init(componentRef: ComponentRef<DetalleCerraduraComponent>, params: object): void {
    this.componentRef = componentRef;
    this.cerradura = params['cerradura'];
  }

  protected  onOpenDetail(): void {
    setTimeout(() => {
      JqxSubTabsComponent._this.loadDataTabs();
      MenuComponent.getInstance().obsListComponent.next(this.detalleCerradura);
    }, 200);
  }

  protected jqxSubTabShouldShowLoader(event: boolean): void{
    if(event) {
      this.loading.set(true);
      return;
    }

    this.loading.set(false);
  }

  protected onCloseForm(): void {
    this.closeForm.emit();
    this.componentRef.destroy()
  }
}
